<template>
  <div>
    <Headers :windowWidth="windowWidth" />
    <div class="detail">
      <!-- 顶部面包屑 -->
      <div class="top_box">
        <div class="title1" @click="gotoback">
          {{ $t("detail.carbonProject") }}
        </div>
        <div class="title2">/</div>
        <div class="title3">{{ $t("detail.projectDetail") }}</div>
      </div>
      <div>
        <el-row type="flex" class="nfdtTitle">
          <el-col> {{ $t("carbonIndex.nfdtId") }}: {{detail.id}}</el-col>
        </el-row>
        <el-row type="flex" class="nfdtTitle">
          <el-col> {{ $t("carbonIndex.nfdtName") }}: {{detail.projectName}}</el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="
            hashList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
          "
          stripe
          
          :header-cell-style="{
            background: '#F0F3F6',
            color: '#626262',
            fontSize: '14px',
            fontFamily: 'ArialMT',
            paddingTop: '17px',
            paddingBottom: '15px',
            paddingLeft: '20px',
          }"
          :cell-style="columnStyle"
          style="width: 100%"
        >
          <!-- @row-click="getnfdtDetail" -->
          <!-- 空状态 -->
          <template slot="empty">
            <p style="margin-top: 50px">
              <img class="data-pic" src="../../assets/img/noData.png" alt="" />
            </p>
            <p class="nodata">No data</p>
          </template>
          <el-table-column  width="100px" :label="$t('carbonIndex.nfdtAction')">
              <template slot-scope="scope">
                {{scope.row.id}}
              </template>
          </el-table-column>
          <el-table-column
            prop="contractAddress"
            :label="$t('carbonIndex.ContractAddress')"
          >
          </el-table-column>
          <el-table-column
            prop="transitionHash"
            :label="$t('carbonIndex.TransactionHash')"
          >
            <template slot-scope="scope">
              <a
                :href="scope.row.transitionHashUrl"
                style="color: #158869; cursor: pointer"
              >
                {{ scope.row.transitionHash }}
              </a>
            </template>
          </el-table-column>
          <el-table-column
            prop="walletAddress"
            :label="$t('carbonIndex.received_wallet_address')"
          >
          </el-table-column>
        </el-table>
        <div class="display_flex dis_end" style="margin-top: 47px">
          <el-pagination
            v-if="hashList.length != 0"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            background
            layout="prev, pager, next"
            class="pagination"
            prev-text="<"
            next-text=">"
            :total="hashList.length"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbonRegistry from "@/api/carbonRegistry.js";
export default {
  components: { Headers },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      pageSize: 10,
      currentPage: 1,
      id: this.$route.query.id,
      detail: {},
      hashList:[]
    };
  },
  //修改列表页的meta值，false时再次进入页面会重新请求数据。
  beforeRouteLeave(to, from, next) {
    if (to.path == "/carbon") {
      to.meta.keepAlive = true;
    }
    next();
  },
  mounted() {
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
          (that.windowHeight = window.fullHeight); // 高
      })();
    };
    that.nfdtDetail();
  },
  methods: {
    columnStyle({ row, column, rowIndex, columnIndex }) {
      console.log('style="text-align:center"',columnIndex)
      if(columnIndex == 0){
          return "text-align:center";
      }
      return "word-break:break-word;padding-left:20px";
    },
    gotoback() {
      this.$router.back();
    },
    handleCurrentChange(updateCurrentPage) {
      this.currentPage = updateCurrentPage;
    },
    hashUrl() {
      this.$router.push("/nfdtHashDetail");
    },
    nfdtDetail() {
      carbonRegistry.nfdtDetail(
        (res) => {
          this.detail = res.data;
          this.hashList = res.data.hashList
        },
        { id: this.id }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.detail {
  width: 1440px;
  max-width: 1440px;
  margin: 0 auto;
  padding-bottom: 50px;
}
.nfdtTitle {
  font-size: 18px;
  margin: 20px 0;
}
.top_box {
  padding: 27px 0 40px 0;
  display: flex;
  .title1 {
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
    cursor: pointer;
  }
  .title2 {
    margin: 0 10px;
    font-size: 20px;
    cursor: pointer;
  }
  .title3 {
    font-size: 20px;
    font-family: ArialMT;
    color: #1e1e1e;
    line-height: 23px;
    cursor: pointer;
  }
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
  }
  .el-breadcrumb__inner {
    font-size: 20px;
    font-family: ArialMT;
    color: #1e1e1e;
    line-height: 23px;
  }
  .el-breadcrumb {
    font-size: 20px;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f4f4f5;
  color: #158869;
}
.viewOn {
  width: 200px;
  border: 1px solid #158869;
  font-size: 16px;
  font-family: ArialMT;
  color: #158869;
  line-height: 23px;
  text-align: center;
  padding: 8px 0;
  border-radius: 10px;
  cursor: pointer;
}
</style>